import { cents, dayLabel, detail, isStale, parseAmount } from '@/components/jobs/ledger/ledgerFormat';

export { cents, dayLabel, detail, isStale, parseAmount };

// Invoice statuses as shown (Overdue is computed by the server: open past its due date).
export const STATUS = {
  draft: { label: 'Draft', cls: 'border-[#D5D8DD] bg-[#F4F5F7] text-[#5C6370]' },
  sent: { label: 'Sent', cls: 'border-[#4575A8]/30 bg-[#E1ECF6] text-[#2F5784]' },
  partially_paid: { label: 'Partially paid', cls: 'border-[#C4A561]/40 bg-[#F7EFD9] text-[#9C7B36]' },
  overdue: { label: 'Overdue', cls: 'border-[#B45353]/30 bg-[#F4DEDE] text-[#B45353]' },
  paid: { label: 'Paid', cls: 'border-[#4A7C59]/30 bg-[#E8F0EA] text-[#4A7C59]' },
  void: { label: 'Voided', cls: 'border-[#D5D8DD] bg-white text-[#8A8F99] line-through' },
};
export const TERMS = [{ value: 0, label: 'Due on receipt' }, { value: 15, label: 'Net 15' }, { value: 30, label: 'Net 30' }];
export const termsLabel = (d) => TERMS.find((t) => t.value === d)?.label || `Net ${d}`;
export const METHODS = [{ value: 'check', label: 'Check' }, { value: 'ach', label: 'ACH' }, { value: 'cash', label: 'Cash' }, { value: 'other', label: 'Other' }];
export const METHOD_LABEL = { ...Object.fromEntries(METHODS.map((m) => [m.value, m.label])), card: 'Card' };
export const ONLINE_METHOD = { card: 'card', bank: 'bank transfer' };
export const QBO = {
  off: { label: 'Not in QuickBooks', cls: 'text-[#8A8F99]' },
  pending: { label: 'Syncing to QuickBooks…', cls: 'text-[#4575A8]' },
  synced: { label: 'In QuickBooks', cls: 'text-[#4A7C59]' },
  failed: { label: 'QuickBooks sync failed', cls: 'text-[#B45353]' },
};
export const BTN = 'inline-flex h-8 items-center justify-center gap-1.5 rounded-sm px-3 text-xs font-semibold transition-colors disabled:opacity-50';
export const GHOST = `${BTN} border border-border bg-white text-[#0D1B2A] hover:bg-muted`;
export const DARK = `${BTN} bg-[#0D1B2A] text-white hover:bg-[#1B2D42]`;
export const INPUT = 'h-9 w-full rounded-sm border border-border bg-white px-2.5 text-sm outline-none transition-colors focus:border-[#4575A8] focus:ring-2 focus:ring-[#4575A8]/20';
export const OVERLINE = 'text-[10px] font-semibold uppercase tracking-[0.16em] text-[#5C6370]';
const joinAnd = (xs) => (xs.length < 2 ? String(xs[0]) : `${xs.slice(0, -1).join(', ')} and ${xs[xs.length - 1]}`);
// Overdue reminder days → "on the due date, then 7, 14 and 30 days after the due date".
export const scheduleText = (days) => {
  const after = days.filter((d) => d > 0);
  const parts = [];
  if (days.includes(0)) parts.push('on the due date');
  if (after.length) parts.push(`${joinAnd(after)} ${after.length === 1 && after[0] === 1 ? 'day' : 'days'} after the due date`);
  return parts.join(', then ');
};
export const when = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');
export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d && typeof d.message === 'string') return d.message;
  return fallback;
};
